import { addSpaceBetweenCamelCase, AgxRow } from '@urbanx/agx-ui-components';
import placeHolderImage from 'assets/images/placeholder-property.png';
import './CampaignImage.scss';
import { AgxTypography } from '@urbanx/agx.ui-components2';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';

interface CampaignImageProps {
  selectedCampaign?: Pick<CampaignDetailModel, 'propertyImageUrls' | 'stage'>;
}

const CampaignImage = ({ selectedCampaign }: CampaignImageProps) => {
  const imageBadge = selectedCampaign?.stage?.replace(/^(Agreement|Listing)/, '');

  return (
    <AgxRow fill extraClasses="propertyImageContainer">
      {imageBadge && (
        <div className="campaignImage-imageBadgeContainer">
          <AgxTypography
            id={'imgBadgeTxt'}
            type={'tag'}
            size={'medium'}
            color="var(--text-brand-main)"
            flexShrink={0}
          >
            {addSpaceBetweenCamelCase(imageBadge)}
          </AgxTypography>
        </div>
      )}
      <img
        alt=""
        className="propertyImage"
        src={
          selectedCampaign?.propertyImageUrls?.large ??
          selectedCampaign?.propertyImageUrls?.medium ??
          placeHolderImage
        }
      />
    </AgxRow>
  );
};

export default CampaignImage;
